import React from 'react';

export default function TpBadge({ value, className = '' }) {
  const v = String(value || '')
    .trim()
    .toUpperCase();
  if (!v) return null;

  const LABELS = {
    CSS: 'CSS',
    ALD: 'ALD',
    AT: 'AT',
    MEDECIN: 'Confrère médecin',
  };
  const COLORS = {
    CSS: 'bg-cyan-50 border-cyan-300 text-cyan-800',
    ALD: 'bg-violet-50 border-violet-300 text-violet-800',
    AT: 'bg-amber-50 border-amber-300 text-amber-800',
    MEDECIN: 'bg-slate-50 border-slate-300 text-slate-700',
    DEFAULT: 'bg-white border-slate-300 text-slate-700',
  };

  const label = LABELS[v] || v;
  const tone = COLORS[v] || COLORS.DEFAULT;

  return (
    <span
      title={`Tiers payant : ${label}`}
      className={`ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs border ${tone} ${className}`}
    >
      {label}
    </span>
  );
}
